import _ from 'underscore';
import { useEffect } from 'react';
import { getParameter } from '@bingads-webui/url-util';
import { AssetEventFeature, useCopilotRecommendationSurvey } from '@bingads-webui-campaign-react/copilot-common';

export function useSurveyTriggers({
  enableCopilotRecommendations,
  isSaving,
  isCanceling,
  themes,
}) {
  const {
    triggerSurveyOnSubmit,
    triggerSurveyOnCancel,
  } = useCopilotRecommendationSurvey(AssetEventFeature.DISPLAY_PLUS);

  const isSelenium = getParameter('isselenium');

  useEffect(() => {
    if (enableCopilotRecommendations && isSaving && !isSelenium) {
      triggerSurveyOnSubmit();
    }
  }, [enableCopilotRecommendations, isSaving, isSelenium, triggerSurveyOnSubmit]);

  useEffect(() => {
    if (enableCopilotRecommendations && isCanceling && _.size(themes) > 0 && !isSelenium) {
      triggerSurveyOnCancel();
    }
  }, [isCanceling, triggerSurveyOnCancel, themes, enableCopilotRecommendations, isSelenium]);
}
